module.exports = __webpack_public_path__ + "img/3.a1ea8c45.jpg";